"use client";

import { useEffect } from "react";
import { app, auth } from "@/lib/firebase";
import { getAnalytics, setAnalyticsCollectionEnabled, isSupported } from "firebase/analytics";
import { onAuthStateChanged } from "firebase/auth";
import Script from "next/script";
declare global {
  interface Window {
    UnicornStudio?: {
      init: () => void;
      isInitialized?: boolean;
    };
    lucide?: {
      createIcons: () => void;
    };
  }
}
export function GlobalEffects() {
  useEffect(() => {
    // Firebase Analytics Logic
    const initAnalytics = async () => {
      const supported = await isSupported();
      if (supported) {
        const analyticsInstance = getAnalytics(app);
        onAuthStateChanged(auth, user => {
          // Exclude specific user from analytics
          if (user && user.uid === "EkIixz8no1Ouv5KPwIrQHw9ksKo1") {
            setAnalyticsCollectionEnabled(analyticsInstance, false);
            console.log("Analytics disabled for user:", user.uid);
          } else {
            setAnalyticsCollectionEnabled(analyticsInstance, true);
          }
        });
      }
    };
    initAnalytics();

    // Unicorn Studio Script Logic
    const initUnicorn = () => {
      if (window.UnicornStudio && !window.UnicornStudio.isInitialized) {
        const element = document.querySelector('[data-us-project="aNQ1HJcO2IvNyDCGls8J"]');

        // Check for WebGL support to avoid crashes in environments like PSI
        const hasWebGL = (() => {
          try {
            const canvas = document.createElement('canvas');
            return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
          } catch (e) {
            return false;
          }
        })();
        if (element && hasWebGL) {
          setTimeout(() => {
            try {
              window.UnicornStudio?.init();
              window.UnicornStudio!.isInitialized = true;
            } catch (err) {
              console.warn("Unicorn Studio failed to initialize:", err);
            }
          }, 100);
        }
      }
    };

    // Attempt init if already loaded
    initUnicorn();
    return () => {
      // Cleanup if necessary
    };
  }, []);
  return <>
      <Script src="https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v1.4.29/dist/unicornStudio.umd.js" strategy="lazyOnload" onLoad={() => {
      if (window.UnicornStudio && !window.UnicornStudio.isInitialized) {
        const element_0 = document.querySelector('[data-us-project="aNQ1HJcO2IvNyDCGls8J"]');

        // Check for WebGL support
        const hasWebGL_0 = (() => {
          try {
            const canvas_0 = document.createElement('canvas');
            return !!(window.WebGLRenderingContext && (canvas_0.getContext('webgl') || canvas_0.getContext('experimental-webgl')));
          } catch (e_0) {
            return false;
          }
        })();
        if (element_0 && hasWebGL_0) {
          setTimeout(() => {
            try {
              window.UnicornStudio?.init();
              window.UnicornStudio!.isInitialized = true;
            } catch (err_0) {
              console.warn("Unicorn Studio failed to initialize:", err_0);
            }
          }, 100);
        }
      }
    }} />
      {/* Aura Background */}
      <div className="aura-background-component fixed top-0 left-0 w-full h-[100dvh] z-0 pointer-events-none" data-alpha-mask="80" style={{
      maskImage: "linear-gradient(to bottom, transparent, black 0%, black 80%, transparent)",
      WebkitMaskImage: "linear-gradient(to bottom, transparent, black 0%, black 80%, transparent)"
    }}>
        <div data-us-project="aNQ1HJcO2IvNyDCGls8J" className="absolute top-0 left-0 z-0 w-full h-full opacity-40 mix-blend-color-dodge"></div>
      </div>
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:rounded-lg focus:bg-[#B0D18B] focus:text-[#1E3702] focus:px-4 focus:py-2 font-geist">
        Skip to content
      </a>
    </>;
}